import React, { useState, useEffect } from 'react';
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { Button, Flex, Input, Upload, Select, Spin } from 'antd';
import {
    CAvatar,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCol,
    CProgress,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
} from '@coreui/react'
import { getStyle, hexToRgba } from '@coreui/utils'
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import CIcon from '@coreui/icons-react'
import axios from 'axios';
import { apiUrls } from '../../apiUrls.js';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const baseURL = apiUrls.baseURL;

const MemberReport = () => {
    //const random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);

    useEffect(() => {
        //if (window.innerWidth <= 768) {
        dispatch({ type: 'set', isShow: true })
        //if(permissions.)
        fetchMemberChart()
        //}
    }, [])

    const fetchMemberChart = async () => {

        setLoading(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/GetBarChartMembersData`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;

            setData(result);
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Spin size="large" />
    }
    return (
        <div>
            <HideSidebarInMobileMode/>

              <CCol xs={12} xl={6} className="fullwidth">
                <CCard className="mb-4">
                    <CCardHeader style={{ textAlign: 'center' }}>تعداد اعضا به تفکیک سال ورود</CCardHeader>
                    <CCardBody>
                        <CChartBar
                            data={{
                                labels: data?.years,
                                datasets: [
                                    {
                                        label: 'تعداد اعضاء',
                                        backgroundColor: ['#f87979', 'f87974'],
                                        data: data?.counts,
                                    },
                                ],
                            }}
                            labels="months"
                        />
                    </CCardBody>
                </CCard>
            </CCol>

        </div>
    )
}

export default MemberReport
